<template>
    <div>
        <!-- baas settings -->
        <p class="title is-5">Baas settings</p>

        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Id</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.id" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Private Key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.privateKey" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Api Key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.apiKey" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Api Url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.apiUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Operator</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.operator" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Demo Url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.demoUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import baasService from '../../../../services/baas.service';

export default {
    name: 'client-settings-baas',
    data() {
        return {
            settings: {}
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    async mounted() {
        this.settings = await baasService.getSettingsByClient(this.clientId);
    },
    methods: {
        async save() {
            await baasService.save(this.clientId, this.settings);
        }
    }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/baas.vue